const isSsr = typeof window === "undefined";
const svocId = isSsr ? "" : window.THDCustomer.default.svocID;
const userId = isSsr ? "" : window.THDCustomer.default.userID;

export const HTTP = "http://";
export const HTTPS = "https://";
export const SECURE = "secure";
export const HOME_DEPOT_DEV = "homedepotdev";

export const API_URLS = {
  AUTH_ORDER_DETAILS: "/customer/order/v1/orderdetailsgroup",
  ONLINE_ORDER_HISTORY: "/customer/order/v1/orderhistory",
  SIGNIN: "/auth/view/signin",
  SECURITY_PAGE: "/account/ui/security"
};

/**
 * GETS THE SECURE PATH FOR NON-SECURE PATHS
 * TODO PUT IN ENV FILE
 */
export const THD_SECURE_HOSTS = {
  "homedepot.com": "homedepot.com",
  "www.homedepot.com": "www.homedepot.com",
  "hd-qa71.homedepotdev.com": "hd-qa71.homedepotdev.com",
  "hd-qa74.homedepotdev.com": "hd-qa74.homedepotdev.com",
};

export const THD_NON_SECURE_HOSTS = {
  "secure2.homedepot.com": "homedepot.com",
  "secure.hd-qa71.homedepotdev.com": "hd-qa71.homedepotdev.com",
  "secure.hd-qa74.homedepotdev.com": "hd-qa74.homedepotdev.com",
  "t.secure.hd-qa71.homedepotdev.com": "t.hd-qa71.homedepotdev.com"
};

export const EXT_URLS = {
  TERMS: "/c/PH_MyAccount",
  PRIVACY_POLICY: "/c/Privacy_Security"
};


const B2B_ACCOUNT_PATH = "/b2b/user/account";
const B2B_ACCOUNT_PATH_WITH_USER_ID = `${B2B_ACCOUNT_PATH}/${userId}`;
export const B2B_ACCOUNT_PROFILE_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/customer/${svocId}/profile`;
export const B2B_UPDATE_PROFILE_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/profile`;
export const TRADE_TYPES_PATH = `${B2B_ACCOUNT_PATH}/profile/tradetypes`;